import moment from 'moment-timezone'

const LEGACY_EXPIRY_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const TEHRAN_TIME_ZONE = 'Asia/Tehran'

// Cart mutations currently return legacy timestamps without an offset. They are
// Tehran wall-clock times, so parsing them with the browser's local timezone can
// make a still-valid cart appear expired for customers outside Iran.
export const parseExpiryTime = (expiryTime: string): number | null => {
  const legacyTimestamp = expiryTime.replace('T', ' ')
  const tehranTime = moment.tz(
    legacyTimestamp,
    LEGACY_EXPIRY_FORMAT,
    true,
    TEHRAN_TIME_ZONE
  )

  if (tehranTime.isValid()) {
    return tehranTime.valueOf()
  }

  const parsedTimestamp = moment
    .parseZone(expiryTime, moment.ISO_8601, true)
    .valueOf()
  return Number.isNaN(parsedTimestamp) ? null : parsedTimestamp
}
